import React, { createContext, useState } from "react";
import Encounterform from "./components/Encounterform";
import { PatientFullDetailsType } from "PatientCare/PatientBooking/v1/types";

export type EncounterContextType = {
  encounter: number;
  insuranceId: number;
  searchflag: boolean;

  setEncounter: React.Dispatch<React.SetStateAction<number>>;
  setInusranceId: React.Dispatch<React.SetStateAction<number>>;
  setSearchflag: React.Dispatch<React.SetStateAction<boolean>>;
  encounterDetails: any;

  setEncounterDetails: (details: PatientFullDetailsType | null) => void;
};
const EncounterContextv1 = createContext<EncounterContextType | undefined>(
  undefined
);
export default function PatientEncounterv1() {
  const [encounter, setEncounter] = useState(0);
  const [insuranceId, setInusranceId] = useState(0);
  const [searchflag, setSearchflag] = useState(false);
  const [encounterDetails, setEncounterDetails] = useState<PatientFullDetailsType | null>(null);
  return (
    <EncounterContextv1.Provider
      value={{
        encounter,
        setEncounter,
        insuranceId,
        setInusranceId,
        encounterDetails,
        setEncounterDetails,
        searchflag,
        setSearchflag,
      }}
    >
      <Encounterform />
    </EncounterContextv1.Provider>
  );
}

export { EncounterContextv1 };
